"use client";

import { useEffect } from "react";

/**
 * همان رفتار سوالات متداول سلر آکادمی (`SellerAcademy/Faq.jsx`): وقتی کاربر از صفحه‌ی دیگری با
 * `/ads/#id` می‌رسد، بعد از رندر شدن بخش با اسکرول نرم به آن می‌رود. کلیک روی همان صفحه را
 * `useAnchorClick` هدر انجام می‌دهد.
 */
export default function AdsHashScroll({ id }) {
    useEffect(() => {
        if (window.location.hash !== `#${id}`) return;

        const timer = setTimeout(() => {
            document
                .getElementById(id)
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 400);

        return () => clearTimeout(timer);
    }, [id]);

    return null;
}
